var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrakeFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st14{fill:#FFFFFF;stroke:#ffffff;stroke-miterlimit:10;}\r\n\t.st16{font-size:27.8051px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 24.12,
    cy: 24.26,
    r: 17
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    className: "st14",
    cx: 24.12,
    cy: 24.49,
    r: 13.41
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.87,8.31l2.3,1.86c0,0-13.49,13.49,0,28.19l-2.08,1.86C8.09,40.23-6.39,24.98,7.87,8.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40,8.53l-2.48,1.86c0,0,14.51,13.49,0,28.19l2.24,1.86C39.77,40.45,55.34,25.2,40,8.53z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.0293 0 0 1 19.3164 33.3945)",
    fill: "currentColor",
    className: "st16"
  }, "!"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrakeFailure);
export default __webpack_public_path__ + "static/media/BrakeFailure.2d73f161a9e038c9b57f1e2116c73359.svg";
export { ForwardRef as ReactComponent };